/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SENSYN ID API
 * - ユーザー、組織情報の取得API
 *
 * OpenAPI spec version: 1.0.0
 */
import type {
  GetHealth200
} from '../model';

import getHealthMutator from '../../../mutators/sensyn-id-instance';



  /**
 * - ヘルスチェックAPI
 * @summary getHealth
 */
export const getHealth = (

 ) => {
      return getHealthMutator<GetHealth200>(
      {url: `/healthcheck/`, method: 'GET'
    },
      );
    }
  export type GetHealthResult = NonNullable<Awaited<ReturnType<typeof getHealth>>>
